// extracted by mini-css-extract-plugin
export default {"chart":"DonutChart_chart__VmoLQ"};